import { render, staticRenderFns } from "./MobileBuildForm.vue?vue&type=template&id=8bde992c"
import script from "./MobileBuildForm.vue?vue&type=script&lang=js"
export * from "./MobileBuildForm.vue?vue&type=script&lang=js"
import style0 from "./MobileBuildForm.vue?vue&type=style&index=0&id=8bde992c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports